import { render } from "./SlideMenuItem.vue?vue&type=template&id=3a9a076e"
import script from "./SlideMenuItem.vue?vue&type=script&lang=js"
export * from "./SlideMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__